// AI Generated Pipe
import { Pipe, PipeTransform } from '@angular/core';
import { ActiveFeatureService } from '@monsido/services/active-feature/active-feature.service';

@Pipe({
    name: 'domainActiveFeature',
    standalone: false,
})
export class DomainActiveFeaturePipe implements PipeTransform {
    constructor (private activeFeatureService: ActiveFeatureService) {}

    transform (feature: string, domain?: any, page?: any): boolean {
        if (!feature) {
            return false;
        }
        return this.activeFeatureService.isFeatureActive(feature, domain, page);
    }
}
